import { StyleSheet } from "react-native";
export const styles = StyleSheet.create({
    defaults: {
        margin: 0,
        fontFamily: "Proxima",
    },
});
//# sourceMappingURL=Text.styles.js.map